import {
  type CapturePulseBlockMutation,
  type CapturePulseBlockMutationVariables,
  type PulseV1CapturePulseBlockResponse,
  useCapturePulseBlockMutation,
  withStandardMutationHook,
} from '@spotify/confidence-graphql';

export const useCapturePulseBlock = withStandardMutationHook<
  CapturePulseBlockMutation,
  PulseV1CapturePulseBlockResponse,
  CapturePulseBlockMutationVariables,
  'capturePulseBlock'
>(useCapturePulseBlockMutation, 'capturePulseBlock');
